import { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import LaunchDarklySource from './launch-darkly-source';

/**
 * LaunchDarklySync - Component that syncs LaunchDarkly flags to the Flux store
 *
 * This component should be rendered inside the LDProvider to sync flags
 * to the LaunchDarklyStore, making them accessible from non-React code.
 */
const LaunchDarklySync = ({ children }) => {
  const flags = useFlags();

  useEffect(() => {
    LaunchDarklySource.syncFlags(flags);
  }, [flags]);

  return children;
};

export default LaunchDarklySync;
